import React from 'react'

export default function Fame() {
    return (
        <section className="fame-section pb-100">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="fame-area-content">
                        <span>
                            <i className="flaticon-fame"></i>
                            Our Fame
                        </span>
                        <h3>Reputation is anything is the working capacity is not crucial for them</h3>
                        <p>It’s been 11 years since the opening of Love and Care children’s program and in that time it has gained a positive reputation for providing constructive activities that contributes to reducing crime, illicit activity, malnutrition, illiteracy and homelessness. </p>

                        <div className="row funfact-row">
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="single-fun-fact">
                                    <p>Beneficiaries</p>
                                    <h3>
                                        <span className="sign-icon dolor">$</span>
                                        <span className="odometer odometer-auto-theme" data-count="50">
                                            <div className="odometer-inside">
                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">5</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>

                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">0</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </div>
                                        </span>
                                        <span className="sign-icon">M</span>
                                    </h3>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="single-fun-fact">
                                    <p>Happy Donators</p>
                                    <h3>
                                        <span className="odometer odometer-auto-theme" data-count="458">
                                            <div className="odometer-inside">
                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">4</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>

                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">5</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>

                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">8</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </div>
                                        </span>
                                        <span className="sign-icon">+</span>
                                    </h3>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="single-fun-fact">
                                    <p>Volunteer</p>
                                    <h3>
                                        <span className="odometer odometer-auto-theme" data-count="455">
                                            <div className="odometer-inside"><span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">4</span>
                                                            </span></span></span></span><span
                                                    className="odometer-digit"><span
                                                        className="odometer-digit-spacer">8</span><span
                                                        className="odometer-digit-inner"><span className="odometer-ribbon"><span
                                                                className="odometer-ribbon-inner"><span
                                                                    className="odometer-value">5</span></span></span></span></span><span
                                                    className="odometer-digit"><span
                                                        className="odometer-digit-spacer">8</span><span
                                                        className="odometer-digit-inner"><span className="odometer-ribbon"><span
                                                                className="odometer-ribbon-inner"><span
                                                                    className="odometer-value">5</span></span></span></span></span>
                                            </div>
                                        </span>
                                        <span className="sign-icon">+</span>
                                    </h3>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="single-fun-fact">
                                    <p>Donated Poor</p>
                                    <h3>
                                        <span className="odometer odometer-auto-theme" data-count="220">
                                            <div className="odometer-inside"><span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">2</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>

                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">2</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>

                                                <span className="odometer-digit">
                                                    <span className="odometer-digit-spacer">8</span>
                                                    <span className="odometer-digit-inner">
                                                        <span className="odometer-ribbon">
                                                            <span className="odometer-ribbon-inner">
                                                                <span className="odometer-value">0</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </div>
                                        </span>
                                        <span className="sign-icon">K</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 p-0">
                    <div className="fame-image">
                        <img src="./assets/img/fame.png" alt="image"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}
